export default __webpack_public_path__ + "231df6542cdb535f144d2aeee182ddc3.svg";